/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { Component } from "react";
import styled from "styled-components";

//#region COMPONENTS
import NanoFlex from "../NanoFlex.js";
import Type from "../Typography.js";
import ReactTooltip from "react-tooltip";
import Pie from "./Pie.js";
import List from "./List.js";
//#endregion

//#region UTILS
import { withTranslation } from 'react-i18next';
//#endregion

const StyledDonut = styled(NanoFlex)`
display: row;
flex-wrap: nowrap;
background-color: white;
// width: 23vw;
// height: 25vh;
margin-top: 40px;
  svg {
    display: inline-block;
    vertical-align: middle;
	  transform-origin: 50% 50%;
	  animation: scale .6s;
    margin: 10px;
	
  text {
    font-family: "Open Sans@;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.3px;
    color: #828596;
  }
}

@keyframes scale {
	from { transform: scale(.2); }
	to { transform: scale(.8); }
}
`;

class Donut extends Component {
  constructor(props) {
    super(props);
    this.canvasContainer = React.createRef();

    console.log('props data :', this.props.options);

    this.state = {
      radius: this.props.radius ?? 80,
      hole: this.props.hole ?? 65,
      labels: this.props.labels ?? false,
      percent: this.props.percent ?? false,
      strokeWidth: this.props.strokeWidth ?? 3,
      stroke: this.props.stroke ?? "#fff",
      height: 0,
      width: 0,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.resetDimensions, false);
    this.resetDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resetDimensions, false);
  }

  resetDimensions() {
    this.setState({
      width: this.canvasContainer.clientWidth,
      height: this.canvasContainer.clientHeight,
    });
  }

  render() {
    return (
      <StyledDonut className="donutWrapper">
        {this.props.options.map((m) => m.value).some((val) => val > 0.0001) && (
          <NanoFlex ref={this.canvasContainer}>
            <Pie
              data={this.props.options.map((m) => m.value)}
              name={this.props.options.map((m) => m.name)}
              colors={this.props.options.map((m) => m.color)}
              radius={this.state.radius}
              hole={this.state.hole}
              labels={this.state.labels}
              percent={this.state.percent}
              strokeWidth={this.state.strokeWidth}
              stroke={this.state.stroke}
              height={this.state.height}
              width={this.state.width}
            />
            <ReactTooltip />
          </NanoFlex>
        )}
        {this.props.options.map((m) => m.value).every((val) => val === 0.0001) && (
          <NanoFlex ref={this.canvasContainer}>
            <Type.h2>{this.props.t('noResults')}</Type.h2>
          </NanoFlex>
        )}
        <List options={this.props.options}></List>
      </StyledDonut>
    );
  }
}

export default withTranslation()(Donut);
